import type { EthicSurveyRow } from '../services/ethicData';

/**
 * Shared Ethic survey table shape for PDF/XLSX export (matches ExportHub).
 */
export function buildEthicExportData(
  rows: EthicSurveyRow[],
  deptIdToName: Map<string, string>,
): { headers: string[]; rows: string[][] } {
  const headers = [
    'หน่วยงาน',
    'ประทับเวลา',
    'ตำแหน่งงาน',
    'อายุงาน',
    ...Array.from({ length: 52 }, (_, i) => `ข้อ${i + 1}`),
    'คะแนน',
  ];

  const getAnswer = (row: EthicSurveyRow, q: number): string => {
    const answers = Array.isArray(row.answers)
      ? Object.fromEntries(row.answers.map((v, i) => [i + 1, v]))
      : row.answers;
    const v = (answers as Record<number, number>)[q];
    return typeof v === 'number' && v >= 1 && v <= 5 ? String(v) : '—';
  };

  const dataRows = rows.map((row) => [
    deptIdToName.get(row.departmentId) ?? 'ไม่ทราบชื่อหน่วยงาน',
    row.timestamp,
    row.position,
    row.workExperience,
    ...Array.from({ length: 52 }, (_, i) => getAnswer(row, i + 1)),
    row.score != null ? row.score.toFixed(2) : '-',
  ]);

  return { headers, rows: dataRows };
}
